import React, { useContext, useState, useRef } from "react";
import accounting from "accounting";
import { ShoppingCartContext } from "../../Providers/ShoppingCartProvider/ShoppingCartProvider";
import { ApiService } from "../../Axios/ApiService";

const Product = ({ product }) => {
    const [showSpecifications, setShowSpecifications] = useState(false);
    const [fileStringAfterUpload, setFileStringAfterUpload] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);
    const productFromQuote = !!product.conditions.variation_id;
    const { onCopyProduct, onDeleteProduct, onChangeQty, onRemoveExtraCost } = useContext(
        ShoppingCartContext
    );

    const attributes = [];
    for (const key in product.attributes) {
        if (key === "file_upload") {
            if (!fileStringAfterUpload) {
                attributes.push({
                    key,
                    value: product.attributes[key]
                });
            }
        } else {
            if (key != "prices" && key !== "delivery") {
                attributes.push({
                    key,
                    value: product.attributes[key]
                });
            }
        }
    }

    const changeQty = (qty, delivery_id, variation_id, product) => {
        onChangeQty(qty, delivery_id, variation_id, product);
    };

    const handleFileUpload = async files => {
        setError(false);
        setLoading(true);
        const formData = new FormData();
        formData.append("hash", product.hash);
        Array.from(files).forEach(file => {
            formData.append("uploadFile[]", file);
        });
        try {
            const res = await ApiService.post("/shoppingcart/file", formData);
            setLoading(false);
            const { data } = res;
            console.log(attributes);
            //setFileStringAfterUpload(data.data);
            console.log(data.data);
            console.log(attributes);

            location.reload();

        } catch (e) {
            console.log('error');
            console.log(attributes);
            if (
                e.response &&
                e.response.data &&
                e.response.data.errors &&
                e.response.data.errors.length > 0
            ) {
                setError(e.response.data.errors);
            } else {
                setError([{ id: 0, message: "Uploading failed" }]);
            }
            console.log(e.response);
            //setError(true);
            setLoading(false);
        }
    };

    const deliveryDate = product.attributes.delivery
        ? product.attributes.delivery.split(".")[0]
        : "";
    const deliveryDeadline = product.attributes.delivery
        ? product.attributes.delivery.split(".")[1]
        : "";

    const fileuploadRef = useRef();

    return (
        <>
            <div className="w-full bg-white rounded p-4 border border-gray-200 mb-4 relative flex">
                <div className="hidden lg:block lg:w-3/12 px-4">
                    {product.image && (
                        <img src={`images/products/${product.image}`} alt="" />
                    )}
                </div>
                <div className="flex flex-col w-full lg:w-9/12">
                    <div className="flex mb-4 lg:mb-2 order-1">
                        <div className="w-1/2">
                            <h2 className="font-head text-lg font-bold">
                                {product.name}
                            </h2>
                            <span className="">
                                {accounting.formatMoney(
                                    product.price,
                                    "€",
                                    2,
                                    ".",
                                    ","
                                )}
                            </span>
                        </div>
                        <div className="w-1/2 flex justify-end">
                            <div>
                                {(productFromQuote && product.conditions.quantities.find(price => Number(price) === product.quantity) && !product.attributes.verspreidgebied) ? (
                                    <select
                                        onChange={e =>
                                            changeQty(
                                                e.target.value,
                                                product.conditions.delivery_id,
                                                product.conditions.variation_id,
                                                product
                                            )
                                        }
                                        className="border rounded border-gray-200 p-2"
                                        value={product.quantity}
                                    >
                                        {product.conditions.quantities.map(
                                            qty => (
                                                <option key={qty} value={qty}>
                                                    {qty}{" "}
                                                    {qty === "1"
                                                        ? "stuk"
                                                        : "stuks"}
                                                </option>
                                            )
                                        )}
                                    </select>
                                ) : (
                                    <div className="border rounded border-gray-200 p-2">
                                        {product.quantity}{" "}
                                        {product.quantity === "1" ? "stuk" : "stuks"}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>

                    <div className="bg-blue-100 border border-blue-300 rounded px-3 py-2 mb-4 order-2 lg:order-3">
                        <span className="block text-xs text-gray-600">
                            Levering
                        </span>
                        <span className="block font-bold text-lg text-blue-500">
                            <i className="fas fa-calendar pr-1" />
                            {deliveryDate}
                        </span>
                        <span className="text-xs text-gray-600 leading-tight">
                            {deliveryDeadline}
                        </span>
                    </div>
                    <div className="mb-4 lg:hidden order-3 lg:order-2">
                        {showSpecifications ? (
                            <button
                                onClick={() => setShowSpecifications(false)}
                                className="font-bold text-xs mb-1"
                            >
                                <i className="fas fa-chevron-down pr-1" />{" "}
                                Verberg productspecificaties
                            </button>
                        ) : (
                            <button
                                onClick={() => setShowSpecifications(true)}
                                className="font-bold text-xs"
                            >
                                <i className="fas fa-chevron-right pr-1" />{" "}
                                Bekijk productspecificaties
                            </button>
                        )}

                        {showSpecifications && (
                            <div className="text-sm bg-gray-200 rounded p-2 border border-gray-400">
                                {attributes
                                    .filter(attr => attr.value !== null)
                                    .map(attr => (
                                        <div key={attr.value}>
                                            <span>{attr.value}</span>
                                        </div>
                                    ))}
                            </div>
                        )}
                    </div>
                    <div className="mb-4 hidden lg:block order-3 lg:order-2">
                        <ul className="text-xs list-disc pl-3">
                            {attributes
                                .filter(attr => attr.value !== null)
                                .map(attr => (
                                    <li key={attr.value}>{attr.value}</li>
                                ))}
                        </ul>
                    </div>
                    <div className="flex order-4">
                        <div className="w-12/12 text-gray-600 text-sm">
                            <button
                                onClick={() => onDeleteProduct(product.hash)}
                                className="mr-4 lg:mr-6 mb-2 hover:text-gray-800"
                            >
                                <i className="fas fa-trash-alt" /> Verwijder
                                artikel
                            </button>

                            {productFromQuote && (
                                <button
                                    onClick={() => onCopyProduct(product.hash)}
                                    className="mr-4 lg:mr-6 mb-2 hover:text-gray-800"
                                >
                                    <i className="fas fa-copy" /> Kopieer
                                    artikel
                                </button>
                            )}

                            <input
                                onChange={e => handleFileUpload(e.target.files)}
                                ref={fileuploadRef}
                                type="file"
                                hidden
                            />
                            <button
                                onClick={() => fileuploadRef.current.click()}
                                className="mr-4 lg:mr-6 mb-1 hover:text-gray-800"
                            >
                                <i className="fas fa-file-upload" /> Upload
                                bestand
                            </button>

                            {product.attributes.extra_file_option && (
                                <button
                                    onClick={() => onRemoveExtraCost(product.hash)}
                                    className="mr-4 lg:mr-6 mb-2 hover:text-gray-800"
                                >
                                    <i className="fas fa-times" /> Verwijder extra kosten
                                </button>
                            )}
                        </div>
                    </div>
                    {loading && (
                        <div
                            style={{
                                borderRightColor: "#EBF8FF",
                                borderTopColor: "#EBF8FF",
                                borderBottomColor: "#EBF8FF"
                            }}
                            className="rounded bg-blue-100 border-l-4 border-blue-500 text-blue-900 border p-4 "
                            role="alert"
                        >
                            <p className="font-bold">
                                Bestand aan het uploaden
                            </p>
                            <p>Een ogenblik geduld.</p>
                        </div>
                    )}
                    {error && (
                        <div
                            style={{
                                borderRightColor: "#FEEBC8",
                                borderTopColor: "#FEEBC8",
                                borderBottomColor: "#FEEBC8"
                            }}
                            className="rounded bg-orange-100 border-l-4 border-orange-500 text-orange-700 border p-4 "
                            role="alert"
                        >
                            <p className="font-bold">
                                Er is iets misgaan met het uploaden van het
                                bestand
                            </p>
                            <p>
                                Je kunt de bestanden ook aanleveren via onze{" "}
                                <a
                                    className="hover:underline font-bold"
                                    target="_blank"
                                    href="https://24drukwerk.wetransfer.com"
                                >
                                    Wetransfer
                                </a>
                                .
                            </p>
                        </div>
                    )}
                </div>
            </div>

            {/* <div className="cell large-12 cart-product">
                <div className="grid-x grid-padding-x">
                    <div className="cell large-2 medium-2 show-for-medium">
                        <img src={`images/products/${product.image}`} alt="" />
                    </div>
                    <div className="cell large-10 medium-10">
                        <div className="grid-x align-justify">
                            <div className="cell auto">
                                <div className="grid-x grid-padding-x">
                                    <h2 className="cell small-12">
                                        <b>{product.name}</b>
                                        {!editQty && (
                                            <span>
                                                - {product.quantity}{' '}
                                                {trans('units', false)}
                                            </span>
                                        )}
                                    </h2>
                                    {editQty && (
                                        <div className="cell small-12">
                                            <h6
                                                style={{
                                                    width: '100px',
                                                    display: 'inline',
                                                    marginRight: '12px',
                                                }}
                                            >
                                                {trans('quantity', true)}:
                                            </h6>
                                            <select
                                                style={{
                                                    width: '100px',
                                                    display: 'inline',
                                                }}
                                                defaultValue={product.quantity}
                                                onChange={e =>
                                                    changeQty(
                                                        e.target.value,
                                                        product.conditions
                                                            .delivery_id,
                                                        product.conditions
                                                            .variation_id,
                                                        product
                                                    )
                                                }
                                            >
                                                {product.conditions.quantities.map(
                                                    qty => (
                                                        <option value={qty}>
                                                            {qty}
                                                        </option>
                                                    )
                                                )}
                                            </select>
                                        </div>
                                    )}
                                </div>
                            </div>

                            <h5 className="cell shrink">
                                {accounting.formatMoney(
                                    product.price,
                                    '€',
                                    2,
                                    '.',
                                    ','
                                )}
                            </h5>
                        </div>

                        <div className="grid-x grid-padding-x">
                            <div className="cell large-12">
                                <div className="grid-x grid-padding-x">
                                    {Attributes}
                                    {fileStringAfterUpload && (
                                        <>
                                            <AttributeCell className="cell large-3 medium-3 small-3">
                                                <span>Bestanden</span>
                                            </AttributeCell>
                                            <AttributeCell className="cell large-9 medium-9 small-9">
                                                <span>
                                                    <b>
                                                        {fileStringAfterUpload}
                                                    </b>
                                                </span>
                                            </AttributeCell>
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>

                        <div className="grid-x grid-padding-x grid-margin-y">
                            <div className="cell large-12">
                                {productFromQuote ? (
                                    <Button
                                        onClick={() => toggleQty()}
                                        className="button hollow primary change_qty"
                                    >
                                        <i className="fas fa-pen" />{' '}
                                        {trans('change_quantity', true)}
                                    </Button>
                                ) : null}
                                {productFromQuote ? (
                                    <Button
                                        onClick={() =>
                                            onCopyProduct(product.hash)
                                        }
                                        className="button hollow primary copy"
                                    >
                                        <i className="fas fa-copy" />{' '}
                                        {trans('copy_product', true)}
                                    </Button>
                                ) : null}
                                <input
                                    onChange={e =>
                                        handleFileUpload(e.target.files)
                                    }
                                    ref={fileuploadRef}
                                    type="file"
                                    hidden
                                />
                                <Button
                                    onClick={() =>
                                        fileuploadRef.current.click()
                                    }
                                    className="button hollow primary"
                                >
                                    <i className="fas fa-file-upload" /> Bestand
                                    uploaden
                                </Button>
                                <Button
                                    onClick={() =>
                                        onDeleteProduct(product.hash)
                                    }
                                    className="button hollow alert delete"
                                >
                                    <i className="fas fa-times" />{' '}
                                    {trans('delete_product', true)}
                                </Button>
                            </div>
                            {loading && (
                                <div className="cell large-12">
                                    <StyledLoaderCon>
                                        <Loader />
                                        Bestanden aan het uploaden
                                    </StyledLoaderCon>
                                </div>
                            )}
                            {error && (
                                <div className="cell large-12">
                                    <h6>Er is iets mis gegaan.</h6>
                                        {error.map(e => (
                                            <span key={e.id}>
                                                {e.message[0]}
                                            </span>
                                        ))
                                        }

                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
            <div className="cell large-12">
                <hr className="plain" />
            </div> */}
        </>
    );
};

export default Product;
